import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FieldLabel } from '@puckeditor/core';
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { Button } from 'reactstrap';

import { showModal } from '../../../../actions';
import { getFilePlaceholderElement } from '../../../../helpers/PageSections';

const SliderCollectionPicker = ({
  value,
  onChange,
  label,
  onShowModal,
}) => {
  const intl = useIntl();

  const collection = value || null;

  const handleAdd = (selected) => {
    onChange({ id: uuidv4(), ...selected });
  };

  const handleRemove = () => {
    onChange(null);
  };

  const openModal = () => {
    onShowModal('CollectionSelectModal', {
      className: 'modal-collection-select',
      backdrop: true,
      handleCollectionSelect: handleAdd,
    });
  };

  return (
    <div className="puck-collection-picker-label">
      <FieldLabel label={label}>
        {!collection && (
          <Button size="sm" color="primary" onClick={openModal} className="w-100">
            {intl.formatMessage({ defaultMessage: 'Select Collection' })}
          </Button>
        )}

        {collection && (
          <div className="puck-slider-picker-item">
            <div className="d-flex align-items-center gap-2">
              {collection?.featured_file?.urls?.thumbnail ? (
                <img
                  src={collection.featured_file.urls.thumbnail}
                  alt={collection.name}
                  className="puck-slider-picker-thumb"
                />
              ) : (
                getFilePlaceholderElement({ className: 'puck-slider-picker-thumb' })
              )}
              <span className="ml-1 puck-slider-picker-collection-name">{collection.name}</span>
              <Button
                size="sm"
                color="link"
                className="p-0 px-1 text-danger"
                onClick={handleRemove}
                title={intl.formatMessage({ defaultMessage: 'Remove' })}
              >
                <i className="far fa-trash ml-0" />
              </Button>
            </div>
          </div>
        )}
      </FieldLabel>
    </div>
  );
};

SliderCollectionPicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  onShowModal: PropTypes.func.isRequired,
};

SliderCollectionPicker.defaultProps = {
  value: null,
};

const mapDispatchToProps = (dispatch) => ({
  onShowModal: (modalName, params) => dispatch(showModal(modalName, params)),
});

export default connect(null, mapDispatchToProps)(SliderCollectionPicker);
